// extracted by mini-css-extract-plugin
module.exports = {"icon":"ModerationRejectedTombstoneContainer-icon-99c8f033ea55b4fcd7e0f13f858981da"};